import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class ConsultationService {
	constructor(private http: HttpClient) { }

	liste(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:liste',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	get(id: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:get',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	find(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:find',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

    etats(): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.consultation:etats',
            params: {
                
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

	set(id: any, typeid: any, options: any = []) {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:set',
			params: {
				id: id,
				typeid: typeid,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	changeDate(id: any, options: any = []) {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:changeDate',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	setMultipleConsult(options:any = []) {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:setMultipleConsult',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	consultationListe(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:consultationListe',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getConsultationTypeList(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:getConsultationTypeList',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getConsultationTypeGroupe(typeID, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:getConsultationTypeGroupe',
			params: {
				typeID: typeID,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getconsultation(id: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:getconsultation',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getConsultationTypeActions(code: string, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:getConsultationTypeActions',
			params: {
				code: code,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getConsultationByTiers(tiersID: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:getConsultationByTiers',
			params: {
				tiersID: tiersID,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getListToSave(ids: any, options: any[] = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:getListToSave',
			params: {
				ids: ids,
				options: options,
			}
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	getListByInstruction(instructionID: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:instruction',
			params: {
				id: instructionID,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	calendar( options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:calendrier',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	createAndMoveConsultation(params:any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:createAndMoveConsultation',
			params: {
				params: params
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	createAndMoveVisite(params:any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:createAndMoveVisite',
			params: {
				options: params
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setMultiConsultationStates(consultationsIds,etatId): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:setMultiConsultationStates',
			params: {
				consultationsIds: consultationsIds,
				etatId: etatId
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setMultiConsultationDates(consultations,options = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:setMultiConsultationDates',
			params: {
				consultations: consultations,
				options: options
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getConsultationPlage(consultation): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.consultation:getConsultationPlage',
			params: {
				id: consultation
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
}
